import React, { useState, useEffect, useRef } from "react";

const ChatbotComponent = ({ botId, userId, select, color }) => {
  const [buttonClick, setButtonClick] = useState(false);

  const handleChatButtonClick = () => {
    setButtonClick((prevState) => !prevState);
  };

  const chatWindowRef = useRef(null);

  const handleClickOutside = (e) => {
    if (chatWindowRef.current && !chatWindowRef.current.contains(e.target)) {
      handleChatButtonClick();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const style =
    select === "topRight"
      ? "topRight"
      : select === "bottomLeft"
      ? "bottomLeft"
      : select === "topLeft"
      ? "topLeft"
      : select === "middelLeft"
      ? "middelLeft"
      : select === "middelRight"
      ? "middelRight"
      : "bottomRight";

  return (
    <>
      {!buttonClick ? (
        <button
          id="chatbutton"
          onClick={handleChatButtonClick}
          style={{ backgroundColor: color }}
          className={`fixed  shadow-mdlight1 flex justify-center items-center cursor-pointer bottom-2 right-2 z-[1001] w-[50px] h-[50px] rounded-full p-2 hover:scale-110 border-none ${style}`}>
          <img
            src="https://jaano.ai/chat.svg"
            alt="chat logo"
            className={`max-w-[80%] max-h-[80%] `}
          />
        </button>
      ) : (
        <div className="w-screen h-screen fixed top-0 left-0 z-[1000] flex justify-end items-end p-2">
          <div
            id="chatwindow"
            ref={chatWindowRef}
            className="w-full h-full sm:w-[40%] sm:h-[80%] relative">
            <iframe
              src={`https://jaano.ai/chatapp/${userId}/${botId}/true/false`}
              className="w-full h-full border-none rounded-lg"
              title="Chat Application"
            />

            <button
              onClick={handleChatButtonClick}
              id="closechatwindow"
              className="w-6 h-6 hover:scale-105 rounded-full bg-white absolute top-3 right-2 flex justify-center items-center shadow-md">
              <img
                src="https://jaano.ai/close.svg"
                alt="Close Chat"
                style={{ width: "80%", height: "80%" }}
              />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatbotComponent;
